import {CurrentTabStateTypes} from './getCurrentTabState';

function getLoanPageHeader(CurrentState: CurrentTabStateTypes): string {
  switch (CurrentState) {
    case CurrentTabStateTypes.Both:
      return 'جهت مشاهده جزئیات یا ادامه فرایند دریافت وام‌ها یک گزینه را انتخاب کنید.';
    case CurrentTabStateTypes.TakenLoansOnly:
      return 'جهت مشاهده جزئیات وام‌های دریافت شده یک گزینه را انتخاب کنید.';
    case CurrentTabStateTypes.LoanRequestsOnly:
      return 'جهت دریافت وام فرایند را ادامه دهید.';
    default:
      return '';
  }
}

export default getLoanPageHeader;
